import {Pipe, PipeTransform} from '@angular/core';
import {StandardUnit} from '../_models/StandardUnit';
import * as moment from 'moment';

@Pipe({
  name: 'stringifyUnit'
})

export class StringifyUnitPipe implements PipeTransform {

  prefs = null;
  flagReverse = 'reverse';

  constructor() {
    this.prefs = JSON.parse(localStorage.getItem('currentUser')).user.prefs;
  }

  transform(value: StandardUnit, args: any[]): any {
    let stringValue = '';

    switch (value.unit_type) {
      case 'date_time':

        // Get user preferenced time zone, if not get their local zone.
        const prefZone = this.prefs.time_zone ? this.prefs.time_zone : moment.tz.guess();
        // If a format is prefered then use it, if not use a default.
        const prefFormat = this.prefs.date_format ? this.prefs.date_format : 'DD/MM/YY';
        // Manage formatting in order for moment to understand what we want.
        // if no custom format is given then use a default.
        let stringDate = 'date, time';
        stringDate = stringDate.replace('date', prefFormat);
        stringDate = stringDate.replace('time', 'hh:mm:ss');

        // Take the given time, off set this for our timezone and then format the UTC.
        const localMoment = moment(value.date_value);
        stringValue = localMoment
                        .add(localMoment.tz(prefZone).utcOffset().toString() ,'minutes')
                        .utc()
                        .format(stringDate);
        // console.log('converted time format: ', stringValue);
        break;
      case 'address_location':
        stringValue = value.text;
        break;
      case 'odo':
        if (this.prefs.units_distance === null || this.prefs.units_distance === 'MLS') {
          const milesValue = value.value * 0.621371;
          stringValue += milesValue.toFixed(0) + ' miles';
        } else if (this.prefs.units_distance === 'KMS') {
          stringValue += value.value.toFixed(0) + ' km';

        }
        break;
      case 'battery':
        stringValue += value.text + ' ';
        stringValue += value.value.toFixed(0) + '%';
        break;
      case 'temperature':
        // TODO create and get user preferences for C or F
        if (typeof args !== 'undefined' && args[0] === this.flagReverse) {
          stringValue += value.value.toFixed(1) + '°C :';
          stringValue += value.text;
        } else {
          stringValue += value.text + ': ';
          stringValue += value.value.toFixed(1) + '°C';
        }
        break;
    }


    return stringValue;
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_pipes/stringify-unit.pipe.ts